import { render, staticRenderFns } from "./logo-quarternary.vue?vue&type=template&id=39e864ed&scoped=true&"
import script from "./logo-quarternary.vue?vue&type=script&lang=js&"
export * from "./logo-quarternary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e864ed",
  null
  
)

export default component.exports